// eslint-disable-next-line import/no-unresolved
module.exports = require('./build/OutsideClickHandler');



//////////////////
// WEBPACK FOOTER
// ./~/react-outside-click-handler/index.js
// module id = 861
// module chunks = 0